import useComboBoxInput, { ComboBoxInputProps } from './useComboBoxInput';
import { Selected } from './usePopupKeyboardNavigation';
import { IEntity } from '../../../../../../../types/api/entities/IEntity';
import { usePopup } from './usePopup';
import { Section } from '../types/Section';

export function useComboBox<TResult extends IEntity, TResponse>(
  mapResponse: (response: TResponse) => Section<TResult>[],
  onSelection: (item?: TResult) => void,
  inputProps: ComboBoxInputProps
) {
  const { closeResults, resultsOpen, openResults } = usePopup();
  const { clearInput, error, formInputRef, inputValue, loading, onInput, resetError, response, isValidInputValue } =
    useComboBoxInput<TResponse>(inputProps);

  const results = response && mapResponse(response);

  const onSelectionHandler = ({ event, selectedItem }: Selected<TResult>) => {
    event.preventDefault();
    // ignore plain input
    if (typeof selectedItem === 'string') {
      return;
    }
    onSelection(selectedItem); // propagate selection
    if (selectedItem) {
      closeResults();
      if (formInputRef.current) {
        formInputRef.current.select();
      }
    }
  };
  const getComboBoxProps = (overrideInputValue?: string) => ({
    results,
    onSelection: onSelectionHandler,
    closeResults,
    resultsOpen,
    openResults,
    clearInput,
    error,
    formInputRef,
    inputValue: overrideInputValue || inputValue,
    loading,
    onInput,
    resetError,
    response,
    isValidInputValue,
  });
  return { getComboBoxProps, formInputRef, isValidInputValue };
}
